<template>
  <div>
    <ForbiddenGoodsHead
            :countFilterParams="countFilterParams"
            :showFilter="showFilter"
            @toggleFilter="toggleFilter"
            @selectAll="selectAll"
            @filter="$emit('filter')"
            @reload="$emit('reload')"
            @approve="$emit('approve')"
            @refund="$emit('refund')"
    />

    <div class="table-filter-wrap">
      <ForbiddenGoodsFilter
              :showFilter="showFilter"
              :filterGetParams="filterGetParams"
              @close="closeFilter"
              @changeFilter="data => $emit('changeFilter', data)"
              @resetFilter="$emit('resetFilter')"
      />

      <ForbiddenGoodsTable
              :selectedNow="selectedNow"
              :isModalInfoPopup="isModalInfoPopup"
              :countFilterParams="countFilterParams"
              :itemId="itemId"
              @showMore="$emit('showMore')"
              @resetFilter="$emit('resetFilter')"
              @updateTable="$emit('updateTable')"
              @reload="$emit('reload')"
              @approve="(id) => $emit('approve', id)"
              @refund="(id) => $emit('refund', id)"
              @changeInfoPopup="(val, id) => $emit('changeInfoPopup', val, id)"
              @downloadFiles="type => $emit('downloadFiles', type)"
      />
    </div>
  </div>
</template>

<script>


  import ForbiddenGoodsHead from "./ForbiddenGoodsHead/ForbiddenGoodsHead";
  import ForbiddenGoodsFilter from "./ForbiddenGoodsFilter/ForbiddenGoodsFilter";
  import ForbiddenGoodsTable from "./ForbiddenGoodsTable/ForbiddenGoodsTable";

  export default {
    name: "ForbiddenGoodsTableSection",

    components: {
      ForbiddenGoodsHead,
      ForbiddenGoodsFilter,
      ForbiddenGoodsTable,
    },

    props: {
      countFilterParams: Number,
      filterGetParams: Object,
      isModalInfoPopup: {
        type: Boolean,
        default: false,
      },
      itemId: Number,
    },

    data(){
      return{
        showFilter: false,
        selectedNow: false,
      }
    },

    methods: {
      closeFilter() {
        this.showFilter = false
      },

      toggleFilter() {
        this.showFilter = !this.showFilter
      },

      selectAll(val) {
        this.selectedNow = val
      },
    }
  }
</script>

<style scoped>

</style>
